import React, { useState, useEffect } from "react";
import "./LandingPage4.css";

const LandingPage4 = ({ images, resultImages }) => {
  const [displayCount, setDisplayCount] = useState(8);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Adjust number of images based on screen size
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      
      // Adjust number of visible images based on screen width
      if (window.innerWidth < 480) {
        setDisplayCount(4); // Mobile shows fewer images
      } else if (window.innerWidth < 768) {
        setDisplayCount(7); // Tablet shows more images
      } else {
        setDisplayCount(11); // Desktop shows all images
      }
    };

    // Set initial count
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Get subset of images to display
  const visibleImages = images.slice(0, displayCount);
  
  // Determine how many result images to show based on screen size
  const resultImageCount = windowWidth < 480 ? 2 : 4;
  const visibleResultImages = resultImages.slice(0, resultImageCount);

  return (
    <>
      {/* Gallery Section */}
      <div className="gallery-wrapper">
        <h1 className="gallery-heading">
          <span>Shutter</span>
          <span className="highlighted">Gallery</span>
        </h1>

        <div className="gallery-grid">
          {visibleImages.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              className="gallery-image"
              loading="lazy"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/placeholder.jpg"; // Fallback image
              }}
            />
          ))}
          <div className="gallery-cta">
            <p>Create with Shutter!</p>
            <button onClick={() => window.location.href = '/webapp'}>Try It Yourself</button>
          </div>
        </div>
      </div>


    </>
  );
};

export default LandingPage4;
